/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Settings</h4>

<p>Click to bring up a window with various application settings.</p>
`;

export default function SettingsTooltip() {
    return h('div', { innerHTML: body });
}
